"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Label_1 = __importDefault(require("../Label"));
var Radio_1 = __importDefault(require("../Radio"));
var RadioField = function (_a) {
    var id = _a.id, label = _a.label, disabled = _a.disabled, input = _a.input, rest = __rest(_a, ["id", "label", "disabled", "input"]);
    var radioId = id || input.value;
    return (react_1["default"].createElement(StyledLabel, __assign({ color: "text", htmlFor: radioId, p: "none" }, rest),
        react_1["default"].createElement(Radio_1["default"], __assign({ id: radioId, disabled: disabled }, input)),
        "\u00A0\u00A0",
        label));
};
var StyledLabel = styled_components_1["default"](Label_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  pointer-events: all;\n  font-weight: ", ";\n"], ["\n  cursor: pointer;\n  pointer-events: all;\n  font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontWeights.normal;
});
RadioField.displayName = 'RadioField';
exports["default"] = RadioField;
var templateObject_1;
//# sourceMappingURL=RadioField.js.map